import { atomWithStorage } from "jotai/utils";
import { personalPricingOptions } from "src/data/variables";

export const priceVariantAtom = atomWithStorage(
  "selected-price",
  personalPricingOptions.premiumYear.priceVariant,
);
